var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowsRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon / arrows/right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4225 17.2559C11.0971 17.5814 10.5694 17.5814 10.244 17.2559C9.91856 16.9305 9.91856 16.4028 10.244 16.0774L16.3214 10L10.244 3.92259C9.91856 3.59715 9.91856 3.06951 10.244 2.74408C10.5694 2.41864 11.0971 2.41864 11.4225 2.74408L18.0892 9.41074C18.4146 9.73618 18.4146 10.2638 18.0892 10.5893L11.4225 17.2559ZM3.08917 17.2559C2.76374 17.5814 2.2361 17.5814 1.91066 17.2559C1.58522 16.9305 1.58522 16.4028 1.91066 16.0774L7.98807 10L1.91066 3.92259C1.58522 3.59715 1.58522 3.06951 1.91066 2.74408C2.2361 2.41864 2.76374 2.41864 3.08917 2.74408L9.75584 9.41074C10.0813 9.73618 10.0813 10.2638 9.75584 10.5893L3.08917 17.2559Z",
    fill: "#F3AC3C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsRight);
export default __webpack_public_path__ + "static/media/arrows-right.26146ad49a3df3c4c253a49aeaba4937.svg";
export { ForwardRef as ReactComponent };